import React from "react";
import { Link } from "react-router-dom";
import { ROUTES } from "../../constant/routes";

const HeroSection: React.FC = () => {
  return (
    <section
      className="w-full min-h-[calc(100vh-6.25rem)] bg-cover bg-center bg-no-repeat"
      style={{ backgroundImage: `url(/heroBg.jpg)` }}
    >
      <div className="absolute inset-0 bg-black/50" />
      <div className="relative z-10 max-w-6xl mx-auto px-4 text-white h-auto min-h-[calc(100vh-6.25rem)] flex flex-col justify-center items-center">
        <span className="px-6 py-2 border rounded-full bg-white/30 border-white/40 text-sm font-medium">
          ✨ Welcome to LLB360 ✨
        </span>
        <h1 className="text-2xl sm:text-4xl md:text-6xl font-bold text-center md:leading-20 sm:leading-12  mt-4">
          Your Complete 360° Legal Learning and Mentorship Platform
        </h1>
        <p className="mt-4 max-w-4xl text-md text-myInputBorder text-center">
          Built for law students, LLB360 provides exam-oriented learning,
          concept clarity, and mentorship from experienced legal professionals
          to ensure strong academic performance and deeper legal understanding.
        </p>
        <Link
          to={ROUTES.REGISTER}
          className="bg-myButtonBg text-white px-4 py-2 rounded-md hover:bg-myButtonHover font-medium mt-4"
        >
          Start Exam Preparation
        </Link>
      </div>
    </section>
  );
};

export default HeroSection;
